export var SegmentCodes = /*#__PURE__*/function (SegmentCodes) {
  SegmentCodes[SegmentCodes["LOGGED_IN"] = 21042] = "LOGGED_IN";
  SegmentCodes[SegmentCodes["LOGGED_OUT"] = 21043] = "LOGGED_OUT";
  return SegmentCodes;
}({});